module.exports = __webpack_public_path__ + "static/media/icon-action-email.5c22fe79.svg";